module.exports = __webpack_public_path__ + "img/aqjnpx-img04.30399d83.png";